var ButtonShapeEnum;
(function (ButtonShapeEnum) {
    ButtonShapeEnum["circle"] = "circle";
    ButtonShapeEnum["round"] = "round";
})(ButtonShapeEnum || (ButtonShapeEnum = {}));

var LinkType;
(function (LinkType) {
    LinkType["inPage"] = "inPage";
    LinkType["external"] = "external";
    LinkType["email"] = "email";
    LinkType["phone"] = "phone";
    LinkType["internal"] = "internal";
})(LinkType || (LinkType = {}));

var SizeEnum;
(function (SizeEnum) {
    SizeEnum["xs"] = "xs";
    SizeEnum["s"] = "s";
    SizeEnum["m"] = "m";
    SizeEnum["l"] = "l";
    SizeEnum["xl"] = "xl";
})(SizeEnum || (SizeEnum = {}));

export { ButtonShapeEnum, LinkType, SizeEnum };
